export enum ActionTypes {
	addBlueprint = 'APP_CONTEXT_ADD_BLUEPRINT',
	clearCustomerDesigns = 'APP_CONTEXT_CLEAR_CUSTOMER_DESIGNS',
	deleteBlueprint = 'APP_CONTEXT_DELETE_BLUEPRINT',
	loadBlueprintsStart = 'APP_CONTEXT_LOAD_BLUEPRINTS_START',
	loadBlueprintsSuccess = 'APP_CONTEXT_LOAD_BLUEPRINTS_SUCCESS',
	loadBlueprintsFailure = 'APP_CONTEXT_LOAD_BLUEPRINTS_FAILER',
	loadMoreStart = 'APP_CONTEXT_LOAD_MORE_START',
	loadMoreEnd = 'APP_CONTEXT_LOAD_MORE_END',
	renderingUpdated = 'APP_CONTEXT_RENDERING_UPDATED',
	setDesignPage = 'APP_CONTEXT_SET_DESIGN_PAGE',
	setDesignPriorities = 'APP_CONTEXT_SET_DESIGN_PRIORITIES',
	setIsDirty = 'APP_CONTEXT_SET_IS_DIRTY',
}
